/* W-01/W-02 shell: the ink sidebar (trips, sections, sync) beside the page. */
.shell {
  display: grid;
  grid-template-columns: 248px 1fr;
  min-height: 100vh;
}
.side {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
}
.brand {
  padding: var(--dimension-space-5) var(--dimension-space-4) var(--dimension-space-4);
  border-bottom: 1px solid color-mix(in srgb, var(--color-text-on-inverse) 18%, transparent);
}
.brand span {
  display: block;
  width: 40px;
  height: 2px;
  margin-top: 6px;
  background: var(--color-surface-signal);
}
.group {
  padding: var(--dimension-space-4) var(--dimension-space-4) var(--dimension-space-1);
  opacity: 0.6;
}
.trip {
  display: block;
  padding: var(--dimension-space-2) var(--dimension-space-4);
  color: inherit;
  text-decoration: none;
  border-left: 4px solid transparent;
}
.trip:hover,
.nav a:hover {
  background: color-mix(in srgb, var(--color-text-on-inverse) 8%, transparent);
}
.active {
  border-left-color: var(--color-surface-signal);
  background: color-mix(in srgb, var(--color-text-on-inverse) 10%, transparent);
}
.tripMeta {
  opacity: 0.6;
}
.nav {
  margin-top: var(--dimension-space-4);
  padding-top: var(--dimension-space-2);
  border-top: 1px solid color-mix(in srgb, var(--color-text-on-inverse) 18%, transparent);
}
.nav a {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-2) var(--dimension-space-4);
  color: inherit;
  text-decoration: none;
  border-left: 4px solid transparent;
}
.foot {
  display: flex;
  justify-content: space-between;
  padding: var(--dimension-space-3) var(--dimension-space-4);
  opacity: 0.6;
  border-top: 1px solid color-mix(in srgb, var(--color-text-on-inverse) 18%, transparent);
}
.foot button {
  background: none;
  border: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  padding: 0;
}
/* The appearance setting, at the foot of the sidebar above the account line. */
.theme {
  margin-top: auto;
  padding: var(--dimension-space-3) var(--dimension-space-4) 0;
}
.main {
  min-width: 0;
}
@media (max-width: 899px) {
  .shell {
    grid-template-columns: 1fr;
  }
  .side {
    position: static;
    height: auto;
  }
}
@media print {
  .shell {
    display: block;
  }
  .side {
    display: none;
  }
}
